import React from "react";
import { Routes, Route } from "react-router-dom";
import Accueil from "./accueil/Accueil";
import AnnoncesList from "./annonces/AnnoncesList";
import Annonce from "./annonces/Annonce";
import UnsubscribeNewsletter from "./unsubscribeNewsletter/UnsubscribeNewsletter";
import WrapperConnectedComponent from "../components/wrapper-connected";
import Press from "./press/Press";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <WrapperConnectedComponent>
            <Accueil />
          </WrapperConnectedComponent>
        }
      />
      <Route
        path="espace-presse"
        element={
          <WrapperConnectedComponent>
            <Press />
          </WrapperConnectedComponent>
        }
      />
      <Route
        path="location-vente"
        element={
          <WrapperConnectedComponent>
            <AnnoncesList />
          </WrapperConnectedComponent>
        }
      />
      <Route
        path="location-vente/unsubscribreNewsletter"
        element={<UnsubscribeNewsletter />}
      />
      <Route
        path="location-vente/:annonceUrl"
        element={
          <WrapperConnectedComponent>
            <Annonce />
          </WrapperConnectedComponent>
        }
      />
    </Routes>
  );
};
